export default __webpack_public_path__ + "static/media/SI.664bf23a.svg";